module.exports = __webpack_public_path__ + "static/media/design-presentation.a671b0c4.png";